import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';

import {
  CircularProgressbar,
  buildStyles
} from 'react-circular-progressbar';
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  CartesianGrid,
  Legend, RadialBarChart, RadialBar, AreaChart,
  Area,
} from 'recharts';
import { FiTrendingUp, FiTrendingDown, FiDollarSign, FiCreditCard, FiPieChart, FiCalendar, FiFileText } from 'react-icons/fi';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
function FirstPage() {

  const [selectedFilter, setSelectedFilter] = useState("financialYear"); // Default to financialYear
  const [isDateFilterVisible, setIsDateFilterVisible] = useState(false);

  const [customDateRange, setCustomDateRange] = useState({
    startDate: null,
    endDate: null
  });
  const [corporateTaxData, setCorporateTaxData] = useState(null);

  const [summary, setSummary] = useState({
    total_revenue: 0,
    net_profit_trend: [],
    top_products: [],
    receivables_trend: [],
    cash_flow: { in: 0, out: 0 },
    vat: { in: 0, out: 0 },
    summary_by_region: [],
    alerts: [],
    expense_summary: [],
    summary_dashboard: {
      total_summary: 0,
      summary_target: 0,
      conversion_rate: 0,
      top_summarypeople: [],
      summary_by_product: [],
      sales_by_region: [],
      avg_order_value: 0,
      new_customers: 0,
      pending_quotations: 0,
      pending_invoices: 0,
    },
  });
  useEffect(() => {
  console.log("FULL corporateTaxData:", corporateTaxData);
  console.log("Receivables object:", corporateTaxData?.receivables);
}, [corporateTaxData]);
useEffect(() => {
  console.log('SUMMARY RESPONSE:', summary);
}, [summary]);

const prepareReceivablesData = () => {
  const receivables = summary?.receivables || {};

  const buckets = [
    'Current',
    '1-30 Days',
    '31-60 Days',
    '61-90 Days',
    'Over 90 Days',
  ];

  return buckets.map(bucket => {
    const invoices = receivables[bucket] || [];

    const totalAmount = invoices.reduce(
      (sum, inv) => sum + Number(inv.amount || 0),
      0
    );

    return {
      name: bucket,
      value: totalAmount,
      count: invoices.length,
    };
  });
};



  console.log("Receivables Data:", prepareReceivablesData());

  const preparePayablesData = () => {
    if (!summary.payables) return [];

    return Object.entries(summary.payables).map(([date, transactions]) => ({
      date,
      amount: transactions.reduce((sum, txn) => {
        const amt = parseFloat(txn.amount);
        return sum + (isNaN(amt) ? 0 : amt);
      }, 0)
    })).sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const prepareCashFlowData = () => {
    const cashFlow = summary?.cash_flow;

    if (!Array.isArray(cashFlow)) return [];

    return cashFlow.map(item => ({
      day: item.day,
      month: item.month,
      net_cash: parseFloat(item.net_cash),
    }));
  };


  const prepareExpenseBreakdownData = () => {
    if (!summary.expense_breakdown) return [];
    return summary.expense_breakdown.map(item => ({
      name: item.category?.name || 'Uncategorized',
      value: item.total
    }));
  };
  // const fetchCorporateTax = async (fromDate, toDate) => {
  //     try {
  //         console.log("Fetching Corporate Tax with:", fromDate, toDate);

  //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
  //         const token = JSON.parse(localStorage.getItem('user-info'))?.token;
  //         const origin = localStorage.getItem('user-origin');
  //         const API = process.env.REACT_APP_WEBZASH_URL;
  //         const APIKEY = process.env.REACT_APP_API_KEY;

  //         const response = await axios.get(`${API}/api/reports/corporate_tax`, {
  //             headers: {

  //                 'x-api-key': APIKEY,

  //             },
  //             params: {
  //                 startdate: fromDate,
  //                 enddate: toDate
  //             }
  //         });

  //         setCorporateTaxData(response.data?.data);
  //     } catch (error) {
  //         console.error("Error fetching corporate tax data:", error);
  //     }
  // };
  // const getFinancialYear = () => {
  //   const storedFormData = JSON.parse(localStorage.getItem('formData'));
  //   const financialYear = storedFormData?.financial_year; // Using optional chaining to avoid errors if formData doesn't exist
  //   console.log(financialYear);
  // };
  const [fetchedYears, setFetchedYears] = useState({});

  const fetchCorporateTax = async (fromDate, toDate) => {
    console.log("🔍 fetchCorporateTax called with:", { fromDate, toDate });

    if (!fromDate || !toDate) {
      console.log("❌ Missing dates, skipping API call");
      return;
    }

    const key = `${fromDate}_${toDate}`;
    if (fetchedYears[key]) {
      console.log("📦 Using cached data for:", key);
      setCorporateTaxData(fetchedYears[key]);
      return;
    }

    try {
      console.log("🌐 Making API call to corporate tax endpoint");

      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const token = JSON.parse(localStorage.getItem('user-info'))?.token;
      const origin = localStorage.getItem('user-origin');
      const API = process.env.REACT_APP_WEBZASH_URL;
      const APIKEY = process.env.REACT_APP_API_KEY;

      const response = await axios.get(`${API}/api/reports/corporate_tax`, {
        headers: { 'x-api-key': APIKEY },
        params: { startdate: fromDate, enddate: toDate }
      });

      console.log("✅ Corporate Tax API Response:", response.data);

      setCorporateTaxData(response.data?.data);
      setFetchedYears(prev => ({ ...prev, [key]: response.data?.data }));
    } catch (error) {
      console.error("❌ Error fetching corporate tax data:", error);
      console.error("Error details:", error.response?.data);
    }
  };

  const getFinancialYear = () => {
    const storedFormData = JSON.parse(localStorage.getItem('formData'));
    const financialYear = storedFormData?.financial_year;
    if (!financialYear) return { startDate: null, endDate: null };

    // Assuming format "YYYY-YYYY" e.g., "2024-2025"
    const [startYear, endYear] = financialYear.split('-').map(Number);
    return {
      startDate: `${startYear}-04-01`, // Assuming FY starts April 1
      endDate: `${endYear}-03-31`
    };
  };
  const assetBreakdown = corporateTaxData?.asset_breakdown || [];

let cashBalance = 0;
let bankBalance = 0;

assetBreakdown.forEach(item => {
  const groupId = item?.Ledger?.group_id;
  const closing = parseFloat(item?.[0]?.closing_balance || 0);

  if (groupId === 93) {          // Cash in Hand
    cashBalance += closing;
  }

  if (groupId === 88) {          // Bank Accounts
    bankBalance += closing;
  }
});

const totalBalance = cashBalance + bankBalance;


  // const handleFinancialYearChange = (selectedYear) => {
  //   setSelectedFilter(selectedYear === "custom" ? "customRange" : "financialYear");
  // };
  // const handleFinancialYearChange = (selectedYear) => {
  //   if (selectedYear === "financialYear") {
  //     setSelectedFilter("financialYear");
  //     setIsDateFilterVisible(false); // Hide date fields
  //     fetchSummary(getFinancialYear());
  //     fetchCorporateTax(getFinancialYear());
  //     // fetchAccount(getFinancialYear());
  //     // fetchSale(getFinancialYear());
  //     // fetchOperation(getFinancialYear());
  //   } else {
  //     setSelectedFilter("customRange");
  //     setIsDateFilterVisible(true); // Show date fields when custom is selected
  //     setCustomDateRange({ startDate: null, endDate: null });
  //   }
  // };

  const handleFinancialYearChange = (selectedYear) => {
    if (selectedYear === "financialYear") {
      setSelectedFilter("financialYear");
      setIsDateFilterVisible(false);

      const { startDate, endDate } = getFinancialYear();
      console.log("Financial Year Dates:", startDate, endDate);

      fetchSummary(startDate, endDate);
      // fetchData(startDate, endDate);


      // Pass individual dates, not the object
      if (startDate && endDate) {
        fetchCorporateTax(startDate, endDate);
      }
    } else {
      setSelectedFilter("customRange");
      setIsDateFilterVisible(true);
      setCustomDateRange({ startDate: null, endDate: null });
    }
  };

  // Handle custom date range selection
  const handleCustomDateChange = (startDate, endDate) => {
    setCustomDateRange({ startDate, endDate });
  };

  const handleClearDates = () => {
    setCustomDateRange({ startDate: null, endDate: null });
    setIsDateFilterVisible(false); // Hide date fields after clear
    fetchSummary(null, null);
    fetchCorporateTax(null, null);
    // fetchData(null, null);
    // fetchSale(null, null);
    // fetchOperation(null, null);
    // fetchAccount(null, null);
  };


  // const handleSubmit = () => {
  //   const { startDate, endDate } = customDateRange;
  //   if (startDate && endDate) {
  //     fetchSummary(startDate, endDate);
  //     fetchCorporateTax(startDate, endDate);
  //     // fetchAccount(startDate, endDate);
  //     // fetchOperation(startDate, endDate);
  //     // fetchSale(startDate, endDate);
  //     setIsDateFilterVisible(false); // Hide date fields after submit
  //   }
  // };


  const handleSubmit = () => {
    const { startDate, endDate } = customDateRange;
    console.log("🔄 Handle Submit:", { startDate, endDate });

    if (startDate && endDate) {
      // Ensure dates are in correct format (YYYY-MM-DD)
      const formattedStartDate = `${startDate}-01`; // Add day component
      const formattedEndDate = `${endDate}-31`; // Add day component

      console.log("📅 Formatted Dates:", { formattedStartDate, formattedEndDate });

      fetchSummary(formattedStartDate, formattedEndDate);
      fetchCorporateTax(formattedStartDate, formattedEndDate);
      // fetchData(formattedStartDate, formattedEndDate);
      setIsDateFilterVisible(false);
    } else {
      console.log("❌ Missing dates in handleSubmit");
    }
  };

  const fetchSummary = async (startDate, endDate) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');

      const token = userInfo?.token;

      const response = await axios.get(`${backendUrl}/api/dashboard`, {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,

        },
      });

      setSummary(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.response?.data || error.message);
    }
  };
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const userInfo = JSON.parse(localStorage.getItem("user-info"));
  const token = userInfo?.token;
  const origin = localStorage.getItem("user-origin");

  // Exchange rate constant
  const EXCHANGE_RATE = 3.692;
  const convertToAED = (amount, currency) => {
    const numericAmount = parseFloat(amount) || 0;
    if (currency === 'USD') {
      return numericAmount * EXCHANGE_RATE;
    }
    return numericAmount; // Assuming AED is default
  };
  const [expenses, setExpenses] = useState([]);

  const fetchData = async (startDate, endDate) => {
    try {
      const response = await axios.get(`${backendUrl}/api/expense-report`, {
        params: {
          dateRange: 'custom', // Add this parameter
          fromDate: startDate, // Use fromDate instead of start_date
          toDate: endDate,     // Use toDate instead of end_date
          // Remove start_date and end_date
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Tenant-Origin": origin,
        }
      });

      const data = response.data.data || [];
      // Add AED conversions to each expense
      const dataWithAED = data.map(expense => ({
        ...expense,
        amount_aed: convertToAED(expense.amount_excl_vat, expense.vendor_currency),
        vat_amount_aed: convertToAED(expense.vat_amount, expense.vendor_currency),
        adjustment_amount_aed: convertToAED(expense.adjustment_amount || 0, expense.vendor_currency),
        total_aed: convertToAED(expense.total, expense.vendor_currency)
      }));

      setExpenses(dataWithAED);
      calculateSummary(dataWithAED);
    } catch (error) {
      console.error("Error loading expense report:", error);
    }
  };
  const calculateSummary = (data) => {
    let totalAmount = 0;
    let totalVAT = 0;
    let adjustmentAmount = 0;
    let totalAmountAED = 0;
    let totalVATAED = 0;
    let adjustmentAmountAED = 0;
    let paymentMethods = {
      cash: 0,
      bank: 0,
      other: 0
    };
    let paymentMethodsAED = {
      cash: 0,
      bank: 0,
      other: 0
    };

    data.forEach(expense => {
      const amount = parseFloat(expense.amount_excl_vat);
      const vat = parseFloat(expense.vat_amount);
      const adjustment = parseFloat(expense.adjustment_amount || 0);
      const total = parseFloat(expense.total);

      const amountAED = parseFloat(expense.amount_aed);
      const vatAED = parseFloat(expense.vat_amount_aed);
      const adjustmentAED = parseFloat(expense.adjustment_amount_aed);
      const totalAED = parseFloat(expense.total_aed);

      totalAmount += amount;
      totalVAT += vat;
      adjustmentAmount += adjustment;

      totalAmountAED += amountAED;
      totalVATAED += vatAED;
      adjustmentAmountAED += adjustmentAED;

      if (expense.payment_mode === 'Cash') {
        paymentMethods.cash += total;
        paymentMethodsAED.cash += totalAED;
      } else if (expense.payment_mode === 'Bank') {
        paymentMethods.bank += total;
        paymentMethodsAED.bank += totalAED;
      } else {
        paymentMethods.other += total;
        paymentMethodsAED.other += totalAED;
      }
    });

    setSummary({
      totalAmount,
      totalVAT,
      adjustmentAmount,
      grandTotal: totalAmount + totalVAT + adjustmentAmount,
      totalAmountAED,
      totalVATAED,
      adjustmentAmountAED,
      grandTotalAED: totalAmountAED + totalVATAED + adjustmentAmountAED,
      paymentMethods,
      paymentMethodsAED
    });
  };

  useEffect(() => {
    const { startDate, endDate } = getFinancialYear();
    fetchSummary(startDate, endDate);
    // fetchData(startDate, endDate);

    // Fetch corporate tax data for financial year
    if (startDate && endDate) {
      fetchCorporateTax(startDate, endDate);
    } else {
      console.warn("⚠️ No valid financial year found, falling back to current calendar year");
      const year = new Date().getFullYear();
      fetchCorporateTax(`${year}-01-01`, `${year}-12-31`);
    }
  }, []);

  const barColors = ['#4F46E5', '#6366F1', '#818CF8', '#A5B4FC', '#C7D2FE'];
  const COLORS = ['#4F46E5', '#6366F1', '#818CF8', '#A5B4FC', '#C7D2FE'];
  const summarys = summary.sales_dashboard;
  const progressPercent = ((summary?.total_summary / summary?.summary_target) * 100).toFixed(1);
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-AE', {
      style: 'currency',
      currency: 'AED',
      maximumFractionDigits: 0
    }).format(amount || 0).replace('₹', '₹ ');
  };
  const totalOrders = 100;
  const ordersInProgress = summary?.orders_in_progress ?? 0;
  const progressPercent1 = totalOrders ? (ordersInProgress / totalOrders) * 100 : 0;
  const totalTasks =
    (summary?.tasks_summary?.in_progress ?? 0) +
    (summary?.tasks_summary?.completed ?? 0) +
    (summary?.tasks_summary?.pending ?? 0);

  const completedPercent = totalTasks ? ((summary?.tasks_summary?.completed / totalTasks) * 100).toFixed(0) : 0;
  const inProgressPercent = totalTasks ? ((summary?.tasks_summary?.in_progress / totalTasks) * 100).toFixed(0) : 0;
  const pendingPercent = totalTasks ? ((summary?.tasks_summary?.pending / totalTasks) * 100).toFixed(0) : 0;

  const getCurrentQuarter = () => {
    const month = new Date().getMonth() + 1; // Jan = 0, so +1
    if (month >= 1 && month <= 3) return 'Q1';
    if (month >= 4 && month <= 6) return 'Q2';
    if (month >= 7 && month <= 9) return 'Q3';
    return 'Q4';
  };
  const currentQuarter = getCurrentQuarter();

  const currentVat = useMemo(() => {
    return summary?.tax_summary?.find(q => q.quarter === currentQuarter) || {};
  }, [summary]);

  const formatUSCurrency = (amount) => {
    if (!amount && amount !== 0) return '0.00';
    return parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">
                  Dashboard
                </h4>
              </div>
            </div>
          </div>


          <div className="dashboard-container">
            <div className="d-flex justify-content-end align-items-center mb-3">
              <DropdownButton
                id="financial-year-dropdown"
                title='Filter'
                onSelect={handleFinancialYearChange}
                label='filter'
                variant="outline-primary"
              >
                <Dropdown.Item eventKey="financialYear">
                  This Financial Year
                </Dropdown.Item>
                <Dropdown.Item eventKey="custom">
                  Select Year
                </Dropdown.Item>
              </DropdownButton>

              {/* {selectedFilter === "customRange" && isDateFilterVisible && (
                <div className="d-flex">
                  <input
                    type="month"
                    value={customDateRange.startDate}
                    onChange={(e) => handleCustomDateChange(e.target.value, customDateRange.endDate)}
                    placeholder="Start Date"
                    className="form-control mr-2"
                  />
                  <input
                    type="month"
                    value={customDateRange.endDate}
                    onChange={(e) => handleCustomDateChange(customDateRange.startDate, e.target.value)}
                    placeholder="End Date"
                    className="form-control"
                  />
                  <button onClick={handleClearDates} className="btn btn-secondary ml-2 me-2">
                    Clear
                  </button>
                  <button onClick={handleSubmit} className="btn btn-primary ml-2">
                    Submit
                  </button>
                </div>
              )} */}
              &nbsp;&nbsp;{selectedFilter === "customRange" && isDateFilterVisible && (
                <div className="d-flex align-items-end gap-3">

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {/* START MONTH */}
                    <DatePicker
                      views={["year", "month"]}
                      openTo="year"
                      label="Start Month"
                      value={
                        customDateRange.startDate
                          ? dayjs(customDateRange.startDate, "YYYY-MM")
                          : null
                      }
                      onChange={(newValue) => {
                        handleCustomDateChange(
                          newValue ? newValue.format("YYYY-MM") : "",
                          customDateRange.endDate
                        );
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          className: "form-feild",
                          sx: { width: 180 },
                        },
                        popper: {
                          disablePortal: true,   // ✅ IMPORTANT (Offcanvas fix)
                          sx: { zIndex: 2000 },
                        },
                      }}
                    />

                    {/* END MONTH */}
                    <DatePicker
                      views={["year", "month"]}
                      openTo="year"
                      label="End Month"
                      value={
                        customDateRange.endDate
                          ? dayjs(customDateRange.endDate, "YYYY-MM")
                          : null
                      }
                      onChange={(newValue) => {
                        handleCustomDateChange(
                          customDateRange.startDate,
                          newValue ? newValue.format("YYYY-MM") : ""
                        );
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          className: "form-feild",
                          sx: { width: 180 },
                        },
                        popper: {
                          disablePortal: true,   // ✅ IMPORTANT
                          sx: { zIndex: 2000 },
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <button onClick={handleClearDates} className="btn btn-secondary">
                    Clear
                  </button>

                  <button onClick={handleSubmit} className="btn btn-primary btn-sm">
                    Submit
                  </button>
                </div>
              )}

            </div>


            <div>
              <div className="container-fluid">
                {/* First Row - Revenue, VAT, and Income/Expenses */}
                <div className="row">
                  {/* Left Column - Revenue and Net Profit stacked */}
                  <div className="col-md-3">
                    {/* Revenue Card (half height) */}
                    <div className="card2 mb-3" style={{ height: '130px' }}>
                      <h4>Total Revenue</h4>
                      <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                        {formatUSCurrency(corporateTaxData?.total_income) ?? formatUSCurrency(summary.revenue?.ytd) ?? 0}
                      </p>
                    </div>

                    {/* Net Profit Card (fills remaining space) */}
                    <div className="card2" style={{ height: 'calc(300px - 1rem)' }}>
                      <h4>Sales by Region</h4>
                      <ResponsiveContainer width="100%" height="80%">
                        <PieChart>
                          <Pie
                            data={summary.sales_by_region || []}
                            dataKey="value"
                            nameKey="region"
                            outerRadius={60}
                            label={false}
                            stroke="none"
                          >
                            {(summary.sales_by_region || []).map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                          </Pie>
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  {/* Middle Column - VAT and Region stacked */}
                  <div className="col-md-5">
                    {/* VAT Card (half height) */}
                    {/* <div className="card2 mb-3 p-3 shadow-sm" style={{ height: '100px' }}>
                      <h4>VAT Overview</h4>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="text-muted">VAT Collected:</span>
                        <strong className="font-size-13 text-dark">
                          {summary?.tax_summary?.vat_collected?.toLocaleString() || 0}
                        </strong>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted">Due:</span>
                        <strong className="font-size-13 text-dark">
                          {summary?.tax_summary?.vat_due?.toLocaleString() || 0}
                        </strong>
                      </div>
                    </div> */}

                    <div className="card2 mb-3 p-3 shadow-sm" style={{ height: '130px' }}>
                      <h4>VAT Overview</h4>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="text-muted">VAT Collected:</span>
                        <strong className="font-size-13 text-dark">
                          {/* Fixed: toLocaleString() */}
                          {(corporateTaxData?.output_vat || currentVat?.vat_collected || 0).toLocaleString()}
                        </strong>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="text-muted">Vendor VAT paid:</span>
                        <strong className="font-size-13 text-dark">
                          {/* Fixed: toLocaleString() */}
                          {(corporateTaxData?.input_vat || currentVat?.vat_paid_to_vendor || 0).toLocaleString()}
                        </strong>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted">NET VAT payable:</span>
                        <strong className="font-size-13 text-dark">
                          {(corporateTaxData?.vat_payable || currentVat?.net_vat_liability || 0).toLocaleString()}
                        </strong>
                      </div>
                    </div>


                    {/* Region Card (fills remaining space) */}
                    <div className="card2" style={{ height: 'calc(300px - 1rem)' }}>
                      <h4>Net Profit</h4>
                      <ResponsiveContainer width="100%" height="80%">
                        <LineChart data={summary.net_profit?.monthly_trend || []}>
                          <XAxis dataKey="month" tick={{ fontSize: 10, fill: '#999' }} />
                          <YAxis tick={{ fontSize: 10, fill: '#999' }} />
                          <Tooltip />
                          <Line
                            type="monotone"
                            dataKey="profit"
                            stroke="#C7D2FE"
                            strokeWidth={2}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  {/* Right Column - Income/Expenses (full height) */}
                  <div className="col-md-4">
                    <div className="card2 p-3" style={{ height: '430px' }}>

                      <h4>Income vs Expenses</h4>

                      <div className="row h-100">
                        <div className="col-md-6 h-100">
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={[
                                  {
                                    name: 'Income',
                                    value: Math.max(0, (corporateTaxData?.total_income) || (summary.profit_loss?.income) || 0)
                                  },
                                  {
                                    name: 'Expenses',
                                    value: Math.max(0, (corporateTaxData?.total_expense) || (summary.profit_loss?.expense) || 0)
                                  }
                                ]}
                                cx="50%"
                                cy="45%"
                                innerRadius={60}
                                outerRadius={80}
                                paddingAngle={2}
                                dataKey="value"
                                label={false}
                                stroke="none"
                              >
                                <Cell key="income" fill="#80CBC4" />
                                <Cell key="expense" fill="#AFDDFF" />
                              </Pie>
                              <Legend
                                verticalAlign="bottom"
                                align="center"
                                layout="horizontal"
                                iconType="circle"
                                wrapperStyle={{ paddingTop: 10, bottom: 50 }}
                              />

                              <Tooltip formatter={(value) => [`₹${value.toLocaleString()}`]} />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-center">
                          <div className="mb-2">
                            <div className="d-flex justify-content-between">
                              <span className='font-size-11'>Income:</span>
                              <span className="text-success font-size-11">
                                {formatUSCurrency(corporateTaxData?.total_income || summary.profit_loss?.income || 0).toLocaleString()}
                              </span>
                            </div>
                            <div className="progress mt-1" style={{ height: '7px' }}>
                              <div
                                className="progress-bar bg-success"
                                // style={{
                                //   width: `${summary.profit_loss?.income ?
                                //     (summary.profit_loss.income / (summary.profit_loss.income + summary.profit_loss.expense) * 100) : 0}%`
                                // }}
                                style={{
                                  width: `${(corporateTaxData?.total_income || summary.profit_loss?.income || 0) ?
                                    ((corporateTaxData?.total_income || summary.profit_loss?.income) /
                                      ((corporateTaxData?.total_income || summary.profit_loss?.income || 0) +
                                        (corporateTaxData?.total_expense || summary.profit_loss?.expense || 0)) * 100) : 0}%`
                                }}
                              ></div>
                            </div>
                          </div>
                          <div>
                            <div className="d-flex justify-content-between">
                              <span className='font-size-11'>Expenses:</span>
                              <span className="text-danger font-size-11">
                                {formatUSCurrency(summary.profit_loss?.expense || corporateTaxData?.total_expense || 0).toLocaleString()}
                              </span>
                            </div>
                            <div className="progress mt-1" style={{ height: '7px' }}>
                              <div
                                className="progress-bar bg-danger"
                                // style={{
                                //   width: `${summary.profit_loss?.expense ?
                                //     (summary.profit_loss.expense / (summary.profit_loss.income + summary.profit_loss.expense) * 100) : 0}%`
                                // }}
                                style={{
                                  width: `${(corporateTaxData?.total_expense || summary.profit_loss?.expense || 0) ?
                                    ((corporateTaxData?.total_expense || summary.profit_loss?.expense) /
                                      ((corporateTaxData?.total_income || summary.profit_loss?.income || 0) +
                                        (corporateTaxData?.total_expense || summary.profit_loss?.expense || 0)) * 100) : 0}%`
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Second Row - Other Cards */}
                {/* Second Row - Other Cards */}
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="card2 full-span bar-chart" style={{ height: '250px', marginBottom: '20px' }}>
                      <h4>Top 5 Products</h4>
                      <ResponsiveContainer width="100%" height="80%">
                        <BarChart
                          layout="vertical"
                          data={summary.top_products.map((item, index) => ({
                            name: item.product?.product_name || `Product #${item.product_id}`,
                            quantity: item.total_quantity,
                            fill: COLORS[index % COLORS.length],
                          }))}
                          margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
                        >
                          <XAxis type="number" hide />
                          <YAxis type="category" dataKey="name" hide />
                          <Tooltip />
                          <Bar dataKey="quantity">
                            {summary.top_products.map((_, index) => (
                              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>

                    {/* Monthly Expenses Chart - Added below Top Products */}
                    <div className="card2 full-span line-chart" style={{ height: '250px' }}>
                      <h4>Monthly Expenses</h4>
                      <ResponsiveContainer width="100%" height="80%">
                        <LineChart data={summary.monthly_expenses || []}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="month"
                            tick={{ fontSize: 10 }}
                          />
                          <YAxis
                            tick={{ fontSize: 10 }}
                            tickFormatter={(value) => `${value.toLocaleString()}`}
                            domain={[0, 'dataMax + 50']} // Ensures chart starts at 0 and adds padding
                            tickCount={6} // Controls number of ticks
                            ticks={[0, 100, 200, 300, 400, 500]}
                          />
                          <Tooltip
                            formatter={(value) => [`${value.toLocaleString()}`]}
                            labelFormatter={(month) => `Month: ${month}`}
                          />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="total"
                            name="Expenses"
                            stroke="#EF4444"
                            strokeWidth={2}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card2 full-span line-chart" style={{ height: '400px' }}>
                      <h4>Cash Flow</h4>
                      {/* <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={prepareCashFlowData()}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="day" tick={{ fontSize: 10 }} />
                          <YAxis
                            tick={{ fontSize: 10, }}
                            domain={['dataMin - 100', 'dataMax + 100']}                            
                            tickCount={6}
                            ticks={[0, 1000, 2000, 3000, 4000, 5000]} />
                          <Tooltip
                            formatter={(value) => [formatCurrency(value), 'Net Cash Flow']}
                            labelFormatter={(day) => `Day: ${day}`}
                          />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="net_cash"
                            name="Net Cash Flow"
                            stroke="#4F46E5"
                            strokeWidth={2}
                            dot={{ r: 4 }}
                            activeDot={{ r: 6 }}
                          />
                        </LineChart>
                      </ResponsiveContainer> */}
                      <ResponsiveContainer width="100%" height={300}>
                        <AreaChart data={prepareCashFlowData()}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="day" tick={{ fontSize: 10 }} />
                          <YAxis
                            domain={['dataMin - 100', 'dataMax + 100']}
                            tickFormatter={(value) => formatCurrency(value)}
                          />
                          <Tooltip
                            formatter={(value) => [formatCurrency(value), 'Net Cash Flow']}
                            labelFormatter={(day) => `Day: ${day}`}
                          />
                          <Legend />
                          <Area
                            type="monotone"
                            dataKey="net_cash"
                            name="Net Cash Flow"
                            stroke="#4F46E5"
                            fill="#4F46E5"
                            fillOpacity={0.3}
                          />
                        </AreaChart>
                      </ResponsiveContainer>

                    </div>
                  </div>
                </div>

                {/* Third Row - Smaller Cards */}
                <div className="row mt-3">





                  {/* <div className="col-md-3">
                    <div className="card2" style={{ height: '200px' }}>
                      <h4>Account Summary</h4>
                      <div className="mt-3">
                        <div className="d-flex justify-content-between">
                          <span>Cash Balance:</span>
                          <span className="fw-bold">{formatUSCurrency(corporateTaxData || summary?.account_summary?.cash)}</span>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                          <span>Bank Balance:</span>
                          <span className="fw-bold">{formatUSCurrency(summary?.account_summary?.bank)}</span>
                        </div>
                        <div className="d-flex justify-content-between mt-3 pt-2 border-top">
                          <span>Total:</span>
                          <span className="fw-bold text-primary">{formatUSCurrency(summary?.account_summary?.total_balance)}</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-3">
  <div className="card2" style={{ height: '200px' }}>
    <h4>Account Summary</h4>

    <div className="mt-3">
      <div className="d-flex justify-content-between">
        <span>Cash Balance:</span>
        <span className="fw-bold">
          {formatUSCurrency(cashBalance)}
        </span>
      </div>

      <div className="d-flex justify-content-between mt-2">
        <span>Bank Balance:</span>
        <span className="fw-bold">
          {formatUSCurrency(bankBalance)}
        </span>
      </div>

      <div className="d-flex justify-content-between mt-3 pt-2 border-top">
        <span>Total:</span>
        <span className="fw-bold text-primary">
          {formatUSCurrency(totalBalance)}
        </span>
      </div>
    </div>
  </div>
</div>

                </div>
              </div>
            </div>
            <div className='container-fluid'>
              <div className="row mt-5">
                <div className="col-lg-6">
                  <div className="card2 p-3">
                    <h4 className="mb-3">Sales Dashboard</h4>

                    <div className="row g-3">

                      {/* Total Sales */}
                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Total Sales</h5>
                          <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
                            {summary?.total?.toLocaleString() || 0}
                          </p>
                        </div>
                      </div>

                      {/* Sales Target vs Actual */}
                      <div className="col-md-6">
                        <div className="card3 p-3 text-center">
                          <h6 className="mb-2">Sales Target</h6>
                          <div style={{ width: 80, height: 80, margin: "0 auto" }}>
                            <CircularProgressbar
                              value={summary?.target_progress || 0}
                              text={`${summary?.target_progress || 0}%`}
                              strokeWidth={12}
                              styles={buildStyles({
                                textSize: "16px",
                                pathColor: "#10B981",      // Green color
                                textColor: "#111827",      // Dark text
                                trailColor: "#E5E7EB",     // Light gray background
                              })}
                            />
                          </div>
                        </div>
                      </div>


                      {/* Conversion Rate */}


                      {/* Sales by Product */}
                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Sales by Product</h5>

                          {summary?.by_product?.length ? (
                            <ResponsiveContainer width="100%" height={100}>
                              <BarChart
                                data={summary?.by_product
                                  .map(item => ({ ...item, summary: parseFloat(item.summary) }))
                                  .sort((a, b) => b.summary - a.summary)}
                                layout="vertical"
                                margin={{ top: 5, right: 10, bottom: 5, left: 5 }}
                                barCategoryGap={2}
                                barGap={2}
                              >
                                <defs>
                                  <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor="#4F46E5" stopOpacity={1} />
                                    <stop offset="100%" stopColor="#A5B4FC" stopOpacity={1} />
                                  </linearGradient>
                                </defs>

                                <XAxis type="number" hide />
                                <YAxis type="category" dataKey="product" hide />
                                <Tooltip formatter={(value) => `₹ ${value.toLocaleString()}`} />

                                <Bar
                                  dataKey="sales"
                                  radius={[4, 4, 4, 4]}
                                  fill="url(#barGradient)" // 👈 Use gradient here
                                />
                              </BarChart>
                            </ResponsiveContainer>
                          ) : (
                            <p>No product summary available</p>
                          )}
                        </div>
                      </div>




                      <div className="col-md-6 d-flex flex-column justify-content-between">
                        <div className="card3 p-3 mb-3 flex-fill">
                          <h5>Conversion Rate</h5>
                          <p>{summary?.conversion_rate || 0}%</p>
                        </div>
                        <div className="card3 p-3 flex-fill">
                          <h5>Avg Order Value</h5>
                          <p>{summary?.avg_order_value?.toLocaleString() || 0}</p>
                        </div>
                      </div>
                      <div className="col-md-6 d-flex flex-column justify-content-between">
                        <div className="card3 p-3 mb-3 flex-fill">
                          <h5>New Customers</h5>
                          <p>{summary?.new_customers || 0}</p>
                        </div>
                        <div className="card3 p-3 flex-fill">

                          <h5>Pending Quotations & Invoices</h5>
                          <p>{summary?.pending_documents || 0}</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Sales by Region</h5>

                          <ResponsiveContainer width="100%" height="80%">
                            <PieChart>
                              <Pie
                                data={summary.sales_by_region || []}
                                dataKey="value"
                                nameKey="region"
                                outerRadius={60}
                                label={false}
                                stroke="none"
                              >
                                {(summary.sales_by_region || []).map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>

                        </div>
                      </div>


                      {/* New Customers */}




                    </div>
                  </div><br />
                  <div className="card2 p-3">
                    <h4 className="mb-3">Operations Dashboard</h4>
                    <p className="text-muted mb-4">For monitoring workflow efficiency and resource usage</p>

                    <div className="row g-3">
                      {/* Orders in Progress */}
                      <div className="col-md-3">
                        <div className="card3 p-3">
                          <h5>Orders in Progress</h5>
                          <p style={{ fontSize: '24px', fontWeight: 'bold' }}>
                            {ordersInProgress}
                          </p>
                          <div className="progress mt-2" style={{ height: '6px' }}>
                            <div
                              className="progress-bar bg-warning"
                              style={{ width: `${progressPercent1}%` }}
                            ></div>
                          </div>
                          <small className="text-muted">
                            {Math.round(progressPercent1)}% of total orders
                          </small>
                        </div>
                      </div>


                      {/* Order Fulfillment Time */}
                      <div className="col-md-3">
                        <div className="card3 p-3">
                          <h5>Avg Fulfillment Time</h5>
                          <p style={{ fontSize: '24px', fontWeight: 'bold' }}>

                            {(summary?.avg_order_fulfillment_time / 60 / 24).toFixed(1)} <small>days</small>
                          </p>                         <div className="d-flex justify-content-between small">

                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Project Summary</h5>
                          <div className="row text-center">
                            <div className="col-4">
                              <div className="mb-2">
                                <div style={{ width: 60, height: 60, margin: '0 auto', display: 'flex', alignItems: 'center' }}>
                                  <CircularProgressbar
                                    value={completedPercent}
                                    text={`${completedPercent}%`}
                                    styles={buildStyles({
                                      textSize: '18px',
                                      pathColor: '#10B981',        // Green for completed
                                      trailColor: '#E5E7EB',        // Light gray trail
                                      textColor: '#111827',         // Centered text color
                                    })}
                                  />

                                </div>
                                <small>Completed</small>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="mb-2">
                                <div style={{ width: 60, height: 60, margin: '0 auto' }}>
                                  <CircularProgressbar
                                    value={inProgressPercent}
                                    text={`${inProgressPercent}%`}
                                    styles={buildStyles({
                                      textSize: '18px',
                                      pathColor: '#F59E0B',        // Yellow for in progress
                                      trailColor: '#E5E7EB',       // Light gray for remaining
                                      textColor: '#111827',
                                    })}
                                  />


                                </div>
                                <small>In Progress</small>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="mb-2">
                                <div style={{ width: 60, height: 60, margin: '0 auto' }}>
                                  <CircularProgressbar
                                    value={pendingPercent}
                                    text={`${pendingPercent}%`}
                                    styles={buildStyles({
                                      textSize: '18px',
                                      pathColor: '#EF4444',        // Red for pending
                                      trailColor: '#E5E7EB',
                                      textColor: '#111827',
                                    })}
                                  />

                                </div>
                                <small>Pending</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 
                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Delivery Status</h5>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="d-flex align-items-center mb-2">
                                <span className="badge bg-success me-2"></span>
                                <span>On-time: 78%</span>
                              </div>
                              <div className="progress" style={{ height: '8px' }}>
                                <div
                                  className="progress-bar bg-success"
                                  style={{ width: '78%' }}
                                ></div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center mb-2">
                                <span className="badge bg-danger me-2"></span>
                                <span>Late: 22%</span>
                              </div>
                              <div className="progress" style={{ height: '8px' }}>
                                <div
                                  className="progress-bar bg-danger"
                                  style={{ width: '22%' }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Stock Movement</h5>
                          <ResponsiveContainer width="100%" height={200}>
                            <BarChart
                              data={[
                                { name: 'Incoming', value: 1250 },
                                { name: 'Outgoing', value: 980 }
                              ]}
                              layout="vertical"
                              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                            >
                              <XAxis type="number" />
                              <YAxis type="category" dataKey="name" />
                              <Tooltip />
                              <Bar dataKey="value" fill="#8884d8" />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="card3 p-3">
                          <h5>Open Support Tickets</h5>
                          <p style={{ fontSize: '24px', fontWeight: 'bold' }}>18</p>
                          <div className="d-flex justify-content-between small">
                            <span className="text-danger">↑ 5 new</span>
                            <span className="text-muted">today</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="card3 p-3">
                          <h5>Vendor Performance</h5>
                          <div style={{ width: '100%', height: '120px' }}>
                            <ResponsiveContainer>
                              <RadialBarChart
                                innerRadius="20%"
                                outerRadius="80%"
                                data={[
                                  { name: 'Vendor A', value: 85, fill: '#8884d8' },
                                  { name: 'Vendor B', value: 72, fill: '#83a6ed' },
                                  { name: 'Vendor C', value: 90, fill: '#8dd1e1' }
                                ]}
                                startAngle={180}
                                endAngle={0}
                              >
                                <RadialBar label={{ fill: '#666', position: 'insideStart' }} background dataKey="value" />
                                <Legend iconSize={10} layout="vertical" verticalAlign="middle" align="right" />
                                <Tooltip />
                              </RadialBarChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Resource Utilization</h5>
                          <ResponsiveContainer width="100%" height={200}>
                            <LineChart
                              data={[
                                { name: 'Jan', value: 65 },
                                { name: 'Feb', value: 72 },
                                { name: 'Mar', value: 80 },
                                { name: 'Apr', value: 78 },
                                { name: 'May', value: 85 },
                                { name: 'Jun', value: 82 }
                              ]}
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Line type="monotone" dataKey="value" stroke="#8884d8" />
                            </LineChart>
                          </ResponsiveContainer>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Workflow Bottlenecks</h5>
                          <ul className="bottleneck-list">
                            <li className="d-flex justify-content-between align-items-center mb-2">
                              <span>Order Processing</span>
                              <span className="badge bg-danger">High</span>
                            </li>
                            <li className="d-flex justify-content-between align-items-center mb-2">
                              <span>Quality Check</span>
                              <span className="badge bg-warning">Medium</span>
                            </li>
                            <li className="d-flex justify-content-between align-items-center mb-2">
                              <span>Packaging</span>
                              <span className="badge bg-warning">Medium</span>
                            </li>
                            <li className="d-flex justify-content-between align-items-center">
                              <span>Shipping</span>
                              <span className="badge bg-success">Low</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Tasks Summary</h5>
                          <div className="row text-center">
                            <div className="col-4">
                              <div className="mb-2">
                                <div style={{ width: 60, height: 60, margin: '0 auto' }}>
                                  <CircularProgressbar
                                    value={75}
                                    text={`${75}%`}
                                    styles={buildStyles({
                                      textSize: '24px',
                                      pathColor: '#10B981',
                                      textColor: '#111827',
                                    })}
                                  />
                                </div>
                                <small>Completed</small>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="mb-2">
                                <div style={{ width: 60, height: 60, margin: '0 auto' }}>
                                  <CircularProgressbar
                                    value={20}
                                    text={`${20}%`}
                                    styles={buildStyles({
                                      textSize: '24px',
                                      pathColor: '#F59E0B',
                                      textColor: '#111827',
                                    })}
                                  />
                                </div>
                                <small>In Progress</small>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="mb-2">
                                <div style={{ width: 60, height: 60, margin: '0 auto' }}>
                                  <CircularProgressbar
                                    value={5}
                                    text={`${5}%`}
                                    styles={buildStyles({
                                      textSize: '24px',
                                      pathColor: '#EF4444',
                                      textColor: '#111827',
                                    })}
                                  />
                                </div>
                                <small>Pending</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div></div> */}

                    </div>
                  </div>

                </div>


                <div className="col-md-6">
                  <div className="card2 p-3 mb-4">
                    <h4>Account Dashboard</h4>
                    <div className="row g-3">
                      {/* Profit & Loss Summary */}
                      <div className="col-md-12">
                        <div className="card3 p-3">
                          <h5>Profit & Loss</h5>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Income:</span>
                            <span className="text-success">
                              {formatUSCurrency(summary.profit_loss?.income || corporateTaxData?.total_income || 0)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Expenses:</span>
                            <span className="text-danger">
                              {formatUSCurrency(summary.profit_loss?.expense || corporateTaxData?.total_expense || 0)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between fw-bold">
                            <span>Net Profit:</span>
                            <span className={corporateTaxData?.net_profit >= 0 ? 'text-success' : 'text-danger'}>
                              {formatUSCurrency(summary.profit_loss?.net_profit || corporateTaxData?.net_profit || 0)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Trial Balance */}
                      {/* <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Trial Balance</h5>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Debits:</span>
                            <span>{formatUSCurrency(summary.trial_balance?.debits)}</span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Credits:</span>
                            <span>{formatUSCurrency(summary.trial_balance?.credits)}</span>
                          </div>
                          <div className="d-flex justify-content-between fw-bold">
                            <span>Difference:</span>
                            <span>
                              {Math.abs((summary.trial_balance?.debits || 0) - (summary.trial_balance?.credits || 0))}
                            </span>
                          </div>
                        </div>
                      </div> */}

                      {/* Accounts Receivable */}
                      <div className="col-md-12">
                        <div className="card3 p-3">
                          <h5>Accounts Receivable</h5>
                          <div className="row">
                            <div className="col-md-6" style={{ height: '250px' }}>
                              {prepareReceivablesData().some(item => item.value > 0) ? ( // Check if any non-zero values exist
                                <ResponsiveContainer width="100%" height="100%">
                                  <PieChart>
                                    <Pie
                                      data={prepareReceivablesData().filter(item => item.value > 0)} // Filter out zero values
                                      dataKey="value"
                                      nameKey="name"
                                      cx="50%"
                                      cy="50%"
                                      outerRadius={70}
                                      innerRadius={40}
                                      label={false}
                                    >
                                      {prepareReceivablesData()
                                        .filter(item => item.value > 0)
                                        .map((entry, index) => (
                                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip formatter={(value) => [`${value.toLocaleString()}`, 'Amount']} />
                                    <Legend />
                                  </PieChart>
                                </ResponsiveContainer>
                              ) : (
                                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                                  <div className="text-center text-muted mb-2">
                                    <i className="bi bi-pie-chart" style={{ fontSize: '2rem', opacity: 0.5 }}></i>
                                  </div>
                                  <div className="text-center text-muted">
                                    No outstanding receivables
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="col-md-6">
                              <div className="receivables-details h-100 d-flex flex-column justify-content-center">
                                {prepareReceivablesData().map((item, index) => (
                                  <div key={index} className="d-flex justify-content-between mb-2">
                                    <span className="d-flex align-items-center">
                                      <span
                                        className="color-indicator"
                                        style={{
                                          backgroundColor: item.value > 0 ? COLORS[index % COLORS.length] : '#e5e7eb',
                                          width: '12px',
                                          height: '12px',
                                          borderRadius: '2px',
                                          marginRight: '8px'
                                        }}
                                      ></span>
                                      {item.name}:
                                    </span>
                                    <span className={`text-end ${item.value === 0 ? 'text-muted' : ''}`}>
                                      <div>{formatUSCurrency(item.value)}</div>
                                      <div className="small">{item.count} invoices</div>
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Cash Flow */}
                      {/* <div className="col-md-12">
                        <div className="card3 p-3">
                          <h5>Cash Flow</h5>
                          <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={prepareCashFlowData()}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="day"
                                tick={{ fontSize: 10, }} />
                              <YAxis
                                tick={{ fontSize: 10, }}
                                domain={[0, 'dataMax + 50']} // Ensures chart starts at 0 and adds padding
                                tickCount={6} // Controls number of ticks
                                ticks={[0, 1000, 2000, 3000, 4000, 5000]} />

                              <Tooltip
                                formatter={(value) => [formatCurrency(value), 'Net Cash Flow']}
                                labelFormatter={(day) => `Day: ${day}`}
                              />
                              <Legend />
                              <Line
                                type="monotone"
                                dataKey="net_cash"
                                name="Net Cash Flow"
                                stroke="#4F46E5"
                                strokeWidth={2}
                                dot={{ r: 4 }}
                                activeDot={{ r: 6 }}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                        </div>
                      </div> */}

                      {/* Expense Breakdown */}
                      <div className="col-md-6">
                        <div className="card3 p-3">
                          <h5>Expense Breakdown</h5>
                          {summary.expense_breakdown?.length ? (
                            <>
                              <ResponsiveContainer width="100%" height={200}>
                                <PieChart>
                                  <Pie
                                    data={summary.expense_breakdown.map(item => ({
                                      name: item.category?.name || 'Uncategorized',
                                      value: parseFloat(item.total)
                                    }))}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={70}
                                    label={false}
                                    stroke="none"            >
                                    {summary.expense_breakdown.map((entry, index) => (
                                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                  </Pie>
                                  <Tooltip
                                    formatter={(value) => formatCurrency(value)}
                                  />
                                </PieChart>
                              </ResponsiveContainer>

                            </>
                          ) : (
                            <p className="text-muted">No expense data available</p>
                          )}
                        </div>
                      </div>

                      {/* Upcoming Payment Dues */}
                      <div className="col-lg-6">
                        <div className="card3">
                          <div className="card-header">
                            <h3>Payment Reminders</h3>
                            <div className="card-actions">
                              <span className="badge bg-warning">Upcoming Quarters</span>
                            </div>
                          </div>
                          <div className="card-body">
                            {summary.upcoming_dues?.length ? (
                              <div className="upcoming-dues-list">
                                {summary.upcoming_dues.map((due, index) => {
                                  const dueDate = new Date(due.due_date);
                                  const today = new Date();
                                  const daysRemaining = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

                                  // Only show if within the reminder period (20 days before due date)
                                  if (daysRemaining > 0 && daysRemaining <= 20) {
                                    return (
                                      <div key={index} className="due-item">
                                        <div className="due-content">
                                          <div className="due-title">VAT Payment - {due.quarter}</div>
                                          <div className="due-date">
                                            Due: {dueDate.toLocaleDateString('en-US', {
                                              month: 'short',
                                              day: 'numeric',
                                              year: 'numeric'
                                            })}
                                          </div>
                                        </div>
                                        <div className="due-meta">
                                          <span className={`badge ${daysRemaining <= 7 ? 'bg-danger' : 'bg-warning'
                                            }`}>
                                            {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  }
                                  return null;
                                }).filter(Boolean)}
                              </div>
                            ) : (
                              <div className="empty-state">
                                <FiCalendar size={40} className="empty-icon" />
                                <p className='font-size-12'>No upcoming VAT payments within reminder period</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Accounts Payable Trend */}
                      <div className="col-md-12">
                        <div className="card3 p-3">
                          <h5>Accounts Payable Trend</h5>
                          <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={preparePayablesData()}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="date" />
                              <YAxis domain={[0, 'dataMax + 50']} // Ensures chart starts at 0 and adds padding
                                tickCount={6} // Controls number of ticks
                                ticks={[0, 1000, 2000, 3000, 4000, 5000]} />
                              <Tooltip formatter={(value) => formatCurrency(value)} />
                              <Legend />
                              <Line type="monotone" dataKey="amount" name="Payable Amount" stroke="#E53E3E" strokeWidth={2} />
                            </LineChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div></div></div></div>
  );
}

export default FirstPage;
